import { Component, type ErrorInfo, type ReactNode } from "react";
import { Buton, SistemSayfasi } from "@koclukpanel/ui";

/**
 * HATA SINIRI — bir bileşen patlarsa BEYAZ EKRAN kalmasın
 *
 * ================================================================
 * NEDEN GEREKTİ — ÖLÇÜLDÜ, 04.09.2026
 * ================================================================
 * `Hesabim` testi yazılırken çıktı: `rizalarim` beklenmedik bir şekil
 * dönerse (`yururluktekiSurumler` yoksa `Object.keys` patlıyor)
 * `Onaylarim` **çizim sırasında** istisna atıyor ve React bütün ağacı
 * söküyor. Sonuç: uygulamanın tamamı beyaz.
 *
 * Belirtisi de sebebin olduğu yerde çıkmıyordu — testte
 * *"başka bir ekranın geri düğmesi bulunamadı"* olarak göründü.
 *
 * ================================================================
 * NEDEN "SONRA BAKARIZ" DEĞİLDİ
 * ================================================================
 * Bu uygulamanın kullanıcısı ÇOCUK ve ekran TELEFON. Beyaz bir sayfa
 * yetişkine "bir şeyler bozulmuş, yenileyeyim" dedirtir; öğrenciye
 * hiçbir şey söylemez ve yapabileceği bir şey de bırakmaz. Hata
 * sınırı yokluğu bir tercih değil, eksikti.
 *
 * ================================================================
 * NE KARAR VERİLMEDİ — BİLEREK
 * ================================================================
 * Burada YALNIZCA "beyaz ekran yerine okunabilir bir sayfa" var.
 * Karar gerektiren üç şey **bilerek yapılmadı**:
 *
 * - **Sunucuya bildirim yok.** Hata gövdesi kişisel veri taşıyabilir
 *   (öğrencinin notu, konu adı) ve F-LOG-12 hassas verinin loga
 *   girmesini yasaklıyor. Ne gönderileceği ayrı bir karar.
 * - **Kendiliğinden yenileme yok.** Yenilemek, öğrencinin girdiği ama
 *   göndermediği veriyi kaybettirebilir; kararı kullanıcı veriyor.
 *   Aynı gerekçe `pwa.ts`te de yazılı.
 * - **Teknik ayrıntı gösterilmiyor.** Yığın izi öğrenciye bir şey
 *   anlatmaz; `console.error` geliştiricinin elinde kalıyor.
 *
 * Kabuk `SistemSayfasi`: on sistem ekranının ortak dili ve markaya
 * bağlı. Yeni bir görsel dil uydurulmadı.
 */

interface HataSiniriProps {
  children: ReactNode;
  /** Test için — gerçek uygulamada verilmiyor. */
  onHata?: (hata: Error) => void;
}

interface HataSiniriDurumu {
  hata: Error | null;
}

export class HataSiniri extends Component<HataSiniriProps, HataSiniriDurumu> {
  override state: HataSiniriDurumu = { hata: null };

  static getDerivedStateFromError(hata: Error): HataSiniriDurumu {
    return { hata };
  }

  override componentDidCatch(hata: Error, bilgi: ErrorInfo): void {
    /*
      `console.error` BİLEREK: sunucuya gönderilmiyor (yukarıdaki nota
      bak) ama geliştiricinin tarayıcı konsolunda kalması gerekiyor —
      yoksa hata sınırı, hatayı yalnızca gizleyen bir perde olurdu.
    */
    console.error("Öğrenci uygulamasında çizim hatası:", hata, bilgi.componentStack);
    this.props.onHata?.(hata);
  }

  override render(): ReactNode {
    if (this.state.hata === null) return this.props.children;

    return (
      <SistemSayfasi
        rozet="BEKLENMEYEN HATA"
        baslik="Bu ekran açılamadı"
        isaret="kirik"
        aciklama="Uygulamada bir şey ters gitti. Senin yaptığın bir hata değil."
        eylemler={<Buton onClick={() => window.location.reload()}>Uygulamayı yenile</Buton>}
        /*
          Alt not, öğrencinin yanlış çıkaracağı sonucu önceden
          düzeltiyor — `SistemSayfasi`nın kendi kuralı. Buradaki
          yanlış sonuç "verim gitti" olurdu.
        */
        altNot="Girdiğin veriler telefonunda duruyor; yenileyince kaybolmaz."
      />
    );
  }
}
